import { render } from "./view_incident_reports.html?vue&type=template&id=73bc61c0&external"
import script from "./view_incident_reports.js?vue&type=script&lang=js&external"
export * from "./view_incident_reports.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__